import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, formatPattern } from '../../utils';
import { getAddOrEditDeviceModalIsLoading } from '../homes/selectors';
import { onAddOrEditDeviceModalIsLoading } from '../homes/actions';
import moment from 'moment';

const onHistoricalListIsLoading = isLoading => ({
    type: CONSTANTS.ON_HISTORICAL_LIST_IS_LOADING,
    payload: { isLoading }
});

const onHistoricalList = data => ({
    type: CONSTANTS.ON_HISTORICAL_LIST,
    payload: { data }
});

const onAssistantListIsLoading = isLoading => ({
    type: CONSTANTS.ON_ASSISTANT_LIST_IS_LOADING,
    payload: { isLoading }
});

const onAssitantList = data => ({
    type: CONSTANTS.ON_ASSISTANT_LIST,
    payload: { data }
});

export const onToggleSelectItem = item => ({
    type: CONSTANTS.ON_TOGGLE_SELECT_ITEM,
    payload: { item }
});

export const onClearSelection = () => ({
    type: CONSTANTS.ON_CLEAR_SELECTION,
    payload: { }
});

export const onZoomSelection = (enabled, xmin, xmax, ymin, ymax) => ({
    type: CONSTANTS.ON_ZOOM_SELECTION,
    payload: { enabled, xmin, xmax, ymin, ymax }
});

// ========= THUNKS ============

/**
 * fetchHistoricalEvents
 * - Fetching historical events
 * @since 2.7.0
 *
 * @returns {Promise}
 */
export const fetchHistoricalEvents = (meterId, from, to, minWh) => (dispatch, getState) => {
    // console.log(getState());
    const list = getState().training.get('list');
    if (list.get('isLoading')) return;
    dispatch(onHistoricalListIsLoading(true));
    dispatch(onHistoricalList(fromJS([])));
    return api(
        `${formatPattern(
            REQUEST_URL.HISTORICAL_POWER_USAGE,
            {meterId}
        )}?from=${from}&to=${to}&minWh=${minWh}`
        , METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                // console.log(res.body);
                dispatch(onHistoricalList(fromJS(res.body)));
                dispatch(onHistoricalListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onHistoricalListIsLoading(false));
            throw err;
        });
};

export const fetchAssistantEvents = (meterId, from, to, minWh, lang) => (dispatch, getState) => {
    // console.log(getState());
    const assistant = getState().training.get('assistant');
    if (assistant.get('isLoading')) return;
    dispatch(onAssistantListIsLoading(true));
    dispatch(onAssitantList(fromJS([])));
    return api(
        `${formatPattern(
            REQUEST_URL.DEVICE_ASSISTANT,
            {meterId}
        )}?from=${from}&to=${to}&minWh=${minWh}&lang=${lang}`
        , METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                // console.log(res.body);
                dispatch(onAssitantList(fromJS(res.body)));
                dispatch(onAssistantListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onAssitantList(undefined));
            dispatch(onAssistantListIsLoading(false));
            throw err;
        });
};

export const storeAssistantEvents = (meterId, values, callback) => (dispatch, getState) => {
    dispatch(onAssistantListIsLoading(true));
    api(
        `${formatPattern(REQUEST_URL.DEVICE_ASSISTANT, {
            meterId
        })}`,
        METHOD.POST,
        values
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAssitantList(undefined));
                dispatch(onAssistantListIsLoading(false));
                callback();
                console.log('store completed');
            }
        })
        .catch(err => {
            dispatch(onAssistantListIsLoading(false));
            throw err;
        });
}

export const onAddNewDevice = (meterId, values, homeId) => (dispatch, getState) => {
    const isLoading = getAddOrEditDeviceModalIsLoading(getState());
    if (isLoading || !values) return;
    dispatch(onAddOrEditDeviceModalIsLoading(true));
    return api(
        `${formatPattern(REQUEST_URL.HOME_DETAIL_METER_DEVICE, {
            homeId,
            meterId
        })}?typeId=${values.type}`,
        METHOD.POST,
        values
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditDeviceModalIsLoading(false));
            }
            return res;
        })
        .catch(err => {
            dispatch(onAddOrEditDeviceModalIsLoading(false));
            throw err;
        });
};

export const learnDevice = (meterId,
                            deviceId,
                            event,
                            isAlreadyKnown = false,
                            isDisapprove = false,
                            isType0 = false) => (dispatch, getState) => {

    dispatch(onAddOrEditDeviceModalIsLoading(true));

    const multiPhase = event.is3phase;
    const TS = moment().valueOf();
    const body = {
        ts: TS,
        meter: meterId,
        cid: 'HINT',
        wrongDevice: isAlreadyKnown && isDisapprove ? event.device : undefined,
        device: deviceId,
        type: isType0 ? 0 : (isAlreadyKnown ? (isDisapprove ? 2 : 1) : 3),
        tsPuse: isType0 ? TS : (multiPhase ? event.p1ts : event.ts),
        tsPuse2: multiPhase ? event.p2ts : 0,
        tsPuse3: multiPhase ? event.p3ts : 0,
        delete: 0
    };
    return api(REQUEST_URL.POWER_USAGE_HINT,
        METHOD.POST,
        body,
        null,
        true,
        true
    )
        .then(res => {
            if (res && res.ok) {
                dispatch(onAddOrEditDeviceModalIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onAddOrEditDeviceModalIsLoading(false));
            throw err;
        });
};

/**
 * fetchHistoricalEventsForDevice
 * - Fetching historical events fro device id
 * @since 2.7.4
 *
 * @returns {Promise}
 */
export const fetchHistoricalEventsForDevice = (deviceId, from, to) => (dispatch, getState) => {
    const list = getState().training.get('list');
    if (list.get('isLoading')) return;
    dispatch(onHistoricalListIsLoading(true));
    return api(
        `${formatPattern(
            REQUEST_URL.HISTORICAL_POWER_USAGE_FOR_DEVICE,
            {deviceId}
        )}?from=${from}&to=${to}`
        , METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                // console.log(res.body);
                dispatch(onHistoricalList(fromJS(res.body)));
                dispatch(onHistoricalListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onHistoricalListIsLoading(false));
            throw err;
        });
};

